'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconTwoTrianglesBetweenLines, iconTwoTrianglesBetweenLinesTag } from '@ni/nimble-components/dist/esm/icons/two-triangles-between-lines';
import { wrap } from '../../utilities/react-wrapper';

export type { IconTwoTrianglesBetweenLines };
export { iconTwoTrianglesBetweenLinesTag };
export const NimbleIconTwoTrianglesBetweenLines = wrap(IconTwoTrianglesBetweenLines);